import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserWatchlist, selectUserWatchlist } from '../../features/watchlist/WatchlistSlice';
import EditModal from '../modal/EditModal';
import feedback from '../../assets/image/feedback.png';
import watchlist from '../../assets/image/add.png';

const MobileFeedbackWatchlistActions = ({ stockData, styles }) => {
    const dispatch = useDispatch();
    const userWatchlist = useSelector(selectUserWatchlist);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [feedbackText, setFeedbackText] = useState("");
    const [feedbackSubmitting, setFeedbackSubmitting] = useState(false);
    const [showWatchlistBlock, setShowWatchlistBlock] = useState(false);

    const sendFeedback = (event) => {
        event.stopPropagation();
        setShowFeedbackModal(true);
    };

    const handleFeedbackChange = (e) => {
        setFeedbackText(e.target.value);
    };

    const handleFeedbackSubmit = async (e) => {
        e.preventDefault();
        setFeedbackSubmitting(true);
        // TODO: Replace with actual feedback API call
        setTimeout(() => {
            setFeedbackSubmitting(false);
            setShowFeedbackModal(false);
            setFeedbackText("");
            alert("Thank you for your feedback!");
        }, 1000);
    };

    // Add to watchlist handler
    const addtoWatchlist = (event) => {
        event.stopPropagation();
        console.log(`Adding ${stockData.stockUid}`);

        setShowWatchlistBlock(true);
        // Use a dummy id for now, in real app this should be user's watchlist id
        // const obj = { stock: { stockId: stockData.stockUid }, id: userWatchlist[0]?.id || '' };
        // dispatch(updateUserWatchlist(obj));
    };

    const handleWatchlistSelection = (watchlistItem) => {
        const obj = {
            stock: { stockId: stockData.stockUid }, 
            id: watchlistItem.watchlistUId
        };
        console.log(`Adding ${stockData.stockUid} to watchlist ${watchlistItem.watchlistUId}`);
        dispatch(updateUserWatchlist(obj));
        setShowWatchlistBlock(false);
    };

    return (
        <>
            <div className={styles.card_footer_trend}>
                <div className={styles.footer_block} onClick={sendFeedback}>
                    <span className={styles.card_feedback}>
                        <img src={feedback} alt="" />
                        Feedback
                    </span>
                </div>
                <div className={styles.footer_block} onClick={addtoWatchlist}>
                    <span className={styles.card_watchlist}>
                        <img src={watchlist} alt="" />
                        Watchlist
                    </span>
                </div>
            </div>

            {/* Feedback Modal */}
            <EditModal isOpen={showFeedbackModal || showWatchlistBlock} onClose={() => { setShowFeedbackModal(false); setShowWatchlistBlock(false); }}>
                {showFeedbackModal && (
                    <form onSubmit={handleFeedbackSubmit}>
                        <textarea
                            value={feedbackText}
                            onChange={handleFeedbackChange}
                            rows={5}
                            style={{ width: '100%', marginBottom: 16, resize: 'vertical' }}
                            placeholder="Type your feedback here..."
                            required
                            disabled={feedbackSubmitting}
                        />
                        <button type="submit" className="btn btn-primary" disabled={feedbackSubmitting || !feedbackText.trim()}>
                            {feedbackSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                    </form>
                )}
                {showWatchlistBlock && userWatchlist && userWatchlist.length > 0 && (
                    <div>
                        <strong>Select your watchlist</strong>
                        <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                            {userWatchlist.map((watchlistItem) => (
                                <li
                                    key={watchlistItem.stockId || watchlistItem.stockUid}
                                    style={{
                                        fontSize: 13,
                                        margin: '8px 4px',
                                        padding: '8px 12px',
                                        border: '1px solid #16a66a',
                                        borderRadius: 6,
                                        background: '#f6fff9',
                                        cursor: 'pointer',
                                        display: 'inline-block',
                                        transition: 'background 0.2s',
                                    }}
                                    onClick={() => {
                                        // Add this stock to the selected watchlist
                                        // const obj = { stock: { stockId: stockData.stockUid }, id: watchlistItem.watchlistId };
                                        // console.log(`Adding ${stockData.stockUid} to watchlist ${watchlistItem.watchlistId}`);
                                        // dispatch(updateUserWatchlist(obj));
                                        handleWatchlistSelection(watchlistItem);
                                    }}
                                >
                                    {watchlistItem.watchlistName || watchlistItem.name || watchlistItem.id}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </EditModal>
        </>
    );
};

export default MobileFeedbackWatchlistActions; 